document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".collection-wrapper");
    const slides = Array.from(document.querySelectorAll(".collection-slide"));
    const nextBtn = document.querySelector(".button-next");
    const prevBtn = document.querySelector(".button-prev");

    if (!wrapper || slides.length === 0) return;

    // Find the active slide index
    const activeIndex = slides.findIndex(slide => slide.classList.contains('data_active'));
    const visibleCount = 3; // Number of visible slides at a time

    // Calculate initial scroll position to show the active slide
    let currentIndex = 0;
    if (activeIndex > -1) {
        // Center the active slide if possible
        if (activeIndex < slides.length - Math.floor(visibleCount / 2)) {
            currentIndex = Math.max(0, activeIndex - Math.floor(visibleCount / 2));
        } else {
            currentIndex = slides.length - visibleCount;
        }
        if (currentIndex < 0) currentIndex = 0;
    }

    function updateSlider() {
        const slideWidth = slides[0].offsetWidth + 20; // 20px gap
        wrapper.scrollTo({
            left: currentIndex * slideWidth,
            behavior: "smooth"
        });
        updateButtons();
    }

    function updateButtons() {
        // Disable prev if at start
        if (currentIndex <= 0) {
            prevBtn.setAttribute('disabled', 'disabled');
            prevBtn.style.opacity = '0.5';
            prevBtn.style.pointerEvents = 'none';
        } else {
            prevBtn.removeAttribute('disabled');
            prevBtn.style.opacity = '1';
            prevBtn.style.pointerEvents = 'auto';
        }
        // Disable next if at end
        if (currentIndex >= slides.length - visibleCount) {
            nextBtn.setAttribute('disabled', 'disabled');
            nextBtn.style.opacity = '0.5';
            nextBtn.style.pointerEvents = 'none';
        } else {
            nextBtn.removeAttribute('disabled');
            nextBtn.style.opacity = '1';
            nextBtn.style.pointerEvents = 'auto';
        }
    }

    // Initial scroll to active and button state
    updateSlider();

    // Button click handlers
    nextBtn.addEventListener("click", function () {
        if (currentIndex < slides.length - visibleCount) {
            currentIndex++;
            updateSlider();
        }
    });

    prevBtn.addEventListener("click", function () {
        if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
        }
    });

    // Optional: update on window resize
    window.addEventListener('resize', updateSlider);
});